export const DEALER_SOURCE = 'templates-dealer';
export const GROUP_SOURCE = 'templates-group';
